'use strict';
module.exports = function checkParams(params, fieldNameArray) {
	if (!params) {
		throw new Error('invalid-args');
	}
	if (!Array.isArray(fieldNameArray)) {
		return true;
	}
	const isMissing = key => {
			const value = params && params[key];
			return value === undefined || value === null;
		},
		missingKeys = fieldNameArray.filter(isMissing);
	if (missingKeys.length) {
		throw new Error('invalid-args:'  + missingKeys.join(','));
	}
};
